import React, { useState } from 'react';

import { Button } from 'components/ui/button';
import ManagedInput from 'components/form/managed_input';
import Modal from 'components/modal';
import { MERGE, OVERWRITE } from './helpers';

interface Props {
  dealPropertyName: string;
  projectPropertyName: string;
  saving?: boolean;
  onClose: () => void;
  onComplete: (selection: string) => void;
}

export default function MergeSelection({ dealPropertyName, projectPropertyName, saving, onClose, onComplete }: Props) {
  const [selection, setSelection] = useState('');
  const options = [
    {
      label: `Merge ${projectPropertyName} and ${dealPropertyName}. You can select which fields to merge.`,
      value: MERGE
    },
    { label: `Connect this deal to ${projectPropertyName}`, value: OVERWRITE },
  ];

  return <>
    <Modal.Body className="d-flex flex-column gap-3">
      <label>
        This listing is already linked to {projectPropertyName}. Please select an option to continue:
      </label>
      <ManagedInput
        inline={false}
        name="selection"
        options={options}
        type="radioGroup"
        value={selection}
        onValueChange={setSelection}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button label="Cancel" variant="ghost" onClick={onClose} />
      <Button disabled={!selection || saving} label="Confirm" onClick={() => onComplete(selection)} />
    </Modal.Footer>
  </>;
}
